import { Modal, Button } from 'react-bootstrap';

interface DeleteUserModalProps {
  show: boolean;
  userName: string;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteUserModal = ({
  show,
  userName,
  onClose,
  onConfirm
}: DeleteUserModalProps) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete <strong>{userName}</strong>?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserModal;
